import React from 'react';

import { ReactComponent as PerformanceSnapshotIcon } from '../../../assetsNew/icons/home/performance-snapshot.svg';
import { ReactComponent as UnreadMessagesIcon } from '../../../assetsNew/icons/home/unread-messages.svg';
import { ReactComponent as OngoingBonusesIcon } from '../../../assetsNew/icons/home/ongoing-bonuses.svg';
import { ReactComponent as NewArrivalsIcon } from '../../../assetsNew/icons/home/new-arrivals.svg';
import { ReactComponent as RecommendedCreatorsIcon } from '../../../assetsNew/icons/home/recommended-creators.svg';
import { ReactComponent as TopPerformersIcon } from '../../../assetsNew/icons/home/top-performers.svg';

export const sectionsTypes = {
  PERFORMANCE_SNAPSHOT: 'PERFORMANCE_SNAPSHOT',
  UNREAD_MESSAGES: 'UNREAD_MESSAGES',
  ONGOING_BONUSES: 'ONGOING_BONUSES',
  NEW_ARRIVALS: 'NEW_ARRIVALS',
  RECOMMENDED_CREATORS: 'RECOMMENDED_CREATORS',
  TOP_PERFORMERS: 'TOP_PERFORMERS'
};

export const sections = [
  {
    id: 1,
    key: sectionsTypes.PERFORMANCE_SNAPSHOT,
    open: true,
    icon: <PerformanceSnapshotIcon />,
    title: 'Performance Snapshot',
    subtitle: 'Key metrics from the last 7 days',
    action: 'Go to performance →'
  },
  {
    id: 2,
    key: sectionsTypes.UNREAD_MESSAGES,
    open: true,
    icon: <UnreadMessagesIcon />,
    title: 'Unread Messages',
    subtitle: 'Respond to creators waiting on you',
    action: 'Go to messages →'
  },
  {
    id: 3,
    key: sectionsTypes.ONGOING_BONUSES,
    open: true,
    icon: <OngoingBonusesIcon />,
    title: 'Ongoing Bonuses',
    subtitle: 'Check the status of ongoing bonuses',
    action: 'Go to bonuses →'
  },
  {
    id: 4,
    key: sectionsTypes.NEW_ARRIVALS,
    open: true,
    icon: <NewArrivalsIcon />,
    title: 'New Arrivals',
    subtitle: 'Review and decide what to do with them',
    action: 'Show all →'
  },
  {
    id: 5,
    key: sectionsTypes.RECOMMENDED_CREATORS,
    open: true,
    icon: <RecommendedCreatorsIcon />,
    title: 'Recommended Creators',
    subtitle: 'Review and decide what to do with them',
    action: 'Show all →'
  },
  {
    id: 6,
    key: sectionsTypes.TOP_PERFORMERS,
    open: true,
    icon: <TopPerformersIcon />,
    title: 'Top Performers',
    subtitle: 'Review and decide what to do with them',
    action: 'Show all →'
  }
];